import { render, staticRenderFns } from "./UserHome.vue?vue&type=template&id=ffafa6d8&scoped=true&"
import script from "./UserHome.vue?vue&type=script&lang=ts&"
export * from "./UserHome.vue?vue&type=script&lang=ts&"
import style0 from "./User.scss?vue&type=style&index=0&id=ffafa6d8&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ffafa6d8",
  null
  
)

export default component.exports